import { css } from '@emotion/react';
import styled from '@emotion/styled';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

export const SubTitle = styled.h3`
  ${({ theme }) => css`
    display: block;
    ${theme.fontStyle.text.body16_medium}
  `}
`;

// export const Error = styled.div`
//   ${({ theme }) => css`
//     display: block;
//     margin-top: 3px;
//     ${theme.fontStyle.text.caption_medium}
//     color: ${theme.themeColor.negative};
//   `}
// `;
